import { render, staticRenderFns } from "./commonHeader.vue?vue&type=template&id=79d18b8c&scoped=true&"
import script from "./commonHeader.vue?vue&type=script&lang=js&"
export * from "./commonHeader.vue?vue&type=script&lang=js&"
import style0 from "./commonHeader.vue?vue&type=style&index=0&id=79d18b8c&prod&lang=less&"
import style1 from "./commonHeader.vue?vue&type=style&index=1&id=79d18b8c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d18b8c",
  null
  
)

export default component.exports